<template>
  <div class="invest-container">
    <!-- 头部 -->
    <div class="invest-header">
      <h1 class="invest-title">
        <i class="fas fa-copyright"></i>
        {{ $t('_bq._bqtz') }}
      </h1>
      <div class="invest-tabs">
        <button
          :class="['invest-tab', { active: activeTab === 'list' }]"
          @click="activeTab = 'list'"
        >
          <i class="fas fa-list"></i>
          {{ $t('_ggtf._splb') }}
        </button>
        <button
          :class="['invest-tab', { active: activeTab === 'my' }]"
          @click="activeTab = 'my'"
        >
          <i class="fas fa-user-check"></i>
          {{ $t('_ggtf._wcyd') }}
        </button>
      </div>
    </div>

    <!-- 内容区 -->
    <div class="invest-content">
      <VideoInvestList v-if="activeTab === 'list'" />
      <VideoMyInvestList v-else />
    </div>
  </div>
</template>

<script>
import VideoInvestList from '@/components/adv/VideoInvestList.vue'
import VideoMyInvestList from '@/components/adv/VideoMyInvestList.vue'

export default {
  name: 'CopyrightInvest',
  components: {
    VideoInvestList,
    VideoMyInvestList
  },
  data() {
    return {
      activeTab: 'list'
    }
  }
}
</script>

<style scoped>
/* ============================================================
   版权投资 - 深灰主题
   ============================================================ */

.invest-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background: #14181c;
  min-height: 100vh;
  color: #e8edf2;
}

/* ============================================================
   头部
   ============================================================ */
.invest-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.invest-title {
  font-size: 22px;
  font-weight: 700;
  color: #e8edf2;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.invest-title i {
  color: #ffb300;
}

/* ============================================================
   Tab 切换
   ============================================================ */
.invest-tabs {
  display: flex;
  gap: 4px;
  background: #0f1419;
  padding: 4px;
  border-radius: 10px;
  border: 1px solid #2a3038;
}

.invest-tab {
  padding: 8px 20px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #6a7a8a;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.invest-tab:hover {
  color: #8a949f;
  background: rgba(255, 255, 255, 0.03);
}

.invest-tab.active {
  color: #e8edf2;
  background: rgba(255, 179, 0, 0.12);
}

.invest-tab i {
  font-size: 14px;
}

.invest-tab.active i {
  color: #ffb300;
}

/* ============================================================
   内容区
   ============================================================ */
.invest-content {
  background: #1a1f26;
  border-radius: 14px;
  border: 1px solid #2a3038;
  padding: 20px 24px;
  min-height: 400px;
}

/* ============================================================
   子组件样式穿透
   ============================================================ */
.invest-content :deep(.video-invest-list),
.invest-content :deep(.video-my-invest-list) {
  background: transparent;
  color: #e8edf2;
}

.invest-content :deep(.invest-card) {
  background: #0f1419;
  border: 1px solid #2a3038;
  border-radius: 12px;
  transition: border-color 0.3s ease;
}

.invest-content :deep(.invest-card:hover) {
  border-color: #ffb300;
}

.invest-content :deep(.invest-title-text) {
  color: #e8edf2;
}

.invest-content :deep(.invest-desc) {
  color: #8a949f;
}

.invest-content :deep(.invest-price) {
  color: #ffb300;
}

.invest-content :deep(.invest-btn) {
  background: linear-gradient(135deg, #ffb300, #f57c00);
  color: #0b0d0f;
  border: none;
  border-radius: 50px;
  padding: 8px 24px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.invest-content :deep(.invest-btn:hover) {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 179, 0, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .invest-container {
    padding: 12px 12px 30px;
  }

  .invest-header {
    flex-direction: column;
    align-items: stretch;
    padding: 14px 16px;
    gap: 12px;
  }

  .invest-title {
    font-size: 18px;
    justify-content: center;
  }

  .invest-tabs {
    justify-content: stretch;
  }

  .invest-tab {
    flex: 1;
    justify-content: center;
    padding: 8px 12px;
    font-size: 13px;
  }

  .invest-content {
    padding: 14px 16px;
    border-radius: 12px;
    min-height: 300px;
  }
}

@media (max-width: 480px) {
  .invest-title {
    font-size: 16px;
  }

  .invest-title i {
    font-size: 16px;
  }

  .invest-tab {
    font-size: 12px;
    padding: 6px 10px;
  }

  .invest-tab i {
    font-size: 12px;
  }

  .invest-content {
    padding: 10px 12px;
    min-height: 250px;
  }
}
</style>